<script setup lang="ts">
import { computed } from 'vue';

import type { VRouterTab } from '@components/tabs/VRouterTabs/types';
import VRouterTabs from '@components/tabs/VRouterTabs/VRouterTabs.vue';
import { useI18n } from '@modules/i18n/composables';
import { usePermissionsStore } from '@modules/permissions/store';

import type { IAffiliateTrackersSettingsTabsProps } from './types';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_MAIN,
} from '../../submodules/main/constants';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION,
} from '../../submodules/subaffiliate-condition/constants';
import {
  ADMIN_AFFILIATE_TRACKERS_GROUPS_ROUTE_NAME,
  AFFILIATES_TRACKER_GROUPS_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_GROUPS,
} from '../../submodules/tracker-groups/constants';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS,
} from '../../submodules/trackers-list/constants';

withDefaults(defineProps<IAffiliateTrackersSettingsTabsProps>(), { bottomIndent: true });

const { getTranslation } = useI18n();
const { hasPermission } = usePermissionsStore();

const tabs = computed<VRouterTab[]>(() => [
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_MAIN, 'TAB_NAME').value,
    route: {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME,
    },
  },
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS, 'TAB_NAME').value,
    route: {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME,
    },
  },
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATES_TRACKERS_GROUPS, 'TAB_NAME').value,
    route: {
      name: ADMIN_AFFILIATE_TRACKERS_GROUPS_ROUTE_NAME,
    },
    visible: hasPermission(AFFILIATES_TRACKER_GROUPS_PERMISSIONS.SHOW).value,
  },
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION, 'TAB_NAME').value,
    route: {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME,
    },
  },
]);
</script>

<template>
  <VRouterTabs v-data-qa-auto-id="'VAffiliateTrackersSettingsTabs'"
    :items="tabs"
    :class="{ 'mb-10': bottomIndent }"
    disable-shadow-transition
    replace
  />
</template>
